import { ColumnDef } from "@tanstack/react-table";
import EmptyState from "@/components/EmptyState";
import IconButton from "@/components/IconButton";
import Table from "@/components/Table";
import type { ElectionPastPresidentAssigneeNode } from "../../queries";

export type PastPresidentAssigneesTableProps = {
  loading: boolean;
  assignees: ElectionPastPresidentAssigneeNode[];
  busy: boolean;
  onRemove: (id: string) => void;
};

function buildColumns(
  busy: boolean,
  assigneeCount: number,
  onRemove: (id: string) => void
): ColumnDef<ElectionPastPresidentAssigneeNode, unknown>[] {
  return [
    {
      id: "name",
      header: "Past President",
      accessorFn: (row) => row.name,
      cell: ({ row }) => row.original.name,
      enableSorting: true
    },
    {
      id: "remove",
      header: "",
      size: 56,
      minSize: 56,
      maxSize: 56,
      enableSorting: false,
      cell: ({ row }) => (
        <div className="flex justify-end">
          <IconButton
            name="delete"
            ariaLabel={`Remove ${row.original.name}`}
            onClick={() => onRemove(row.original.id)}
            disabled={busy || assigneeCount <= 1}
            data-testid={`remove-past-president-${row.original.id}`}
          />
        </div>
      )
    }
  ];
}

export default function PastPresidentAssigneesTable({
  loading,
  assignees,
  busy,
  onRemove
}: PastPresidentAssigneesTableProps) {
  return (
    <Table
      loading={loading}
      data={assignees}
      columns={buildColumns(busy, assignees.length, onRemove)}
      data-testid="past-president-assignees-table"
      renderNoDataEmptyState={() => (
        <EmptyState
          iconName="groups"
          title="No Past Presidents on the List"
          caption="Add at least one Past President to generate a roster."
        />
      )}
    />
  );
}
